<my-feedback
  title="选择部门"
  [show]="show"
  [body]="employee_select"
  [bodyStyle]="{ width: '894px' }"
  (sure)="putResult()"
  (cancel)="close()"
>
  <ng-template #employee_select>
    <div class="select-box flexRow pl-xl pr-xl pt-lg pb-md">
      <div class="border-1 select-body selfRadius flexRow">
        <div class="options-box flexFull border-right-1 flexColumn">
          <!--            顶部title-->
          <div class="box-title pl-12 flexRow">
            <div class="clickEle text-center" style="width: 72px">部门</div>
          </div>
          <!--            顶部title End-->
          <!--            中部搜索框-->
          <div class="all-width pl-md pr-md mt-12">
            <nz-input-group [nzPrefix]="searchIcon" [nzSuffix]="clearIcon">
              <input
                [ngModel]="leftSearch"
                nz-input
                class="selfRadius"
                placeholder="搜索部门"
                (keydown.enter)="$event.target.blur()"
                (blur)="searchDepart($event)"
              />
              <ng-template #clearIcon>
                <i
                  nz-icon
                  nzType="close-circle"
                  nzTheme="outline"
                  *ngIf="leftSearch != ''"
                  class="text-gray1 clickEle"
                  (click)="clearSearch()"
                ></i>
              </ng-template>
            </nz-input-group>
          </div>
          <!--            中部搜索框 End-->
          <!--            底部选择框-->
          <div class="all-width pt-12 pl-md pr-md" *ngIf="leftSearch == ''">
            <nz-tree
              [nzData]="allStructure"
              [nzSelectedKeys]="selectIds"
              nzHideUnMatched
              [nzMultiple]="!nzMultiple"
              nzVirtualHeight="360px"
              [nzTreeTemplate]="structureTpl"
              (nzClick)="selectItem($event)"
            >
              <ng-template #structureTpl let-node>
                <!--<i nz-icon nzIconfont="icon_jiagou" *ngIf="node.level == 0" class="structure-icon mr-sm"></i>
                <i
                  nz-icon
                  nzIconfont="icon_pianqu"
                  *ngIf="node.origin['organ_type'] == 1 && node.origin['organ_type_extra'] == 2"
                  class="structure-icon mr-sm"
                ></i>
                <i
                  nz-icon
                  nzIconfont="icon_arrive"
                  *ngIf="node.origin['organ_type'] == 1 && node.origin['organ_type_extra'] == 3"
                  class="structure-icon mr-sm"
                ></i>
                <i
                  nz-icon
                  nzIconfont="icon_zu"
                  *ngIf="(node.origin['organ_type_extra'] == 0 || node.origin['organ_type_extra'] == 4) && node.level > 0"
                  class="structure-icon mr-sm"
                ></i>
                <i nz-icon nzIconfont="icon_user" *ngIf="node.origin['employee_id'] > 6" class="structure-icon mr-sm"></i>-->
                <i
                  nz-icon
                  nzIconfont="icon_institution"
                  class="structure-icon mr-sm"
                  *ngIf="node.level == 0 && node.origin['organ_type'] == 1"
                ></i>
                <i
                  nz-icon
                  nzIconfont="icon_equally"
                  class="structure-icon mr-sm"
                  *ngIf="node.level == 0 && node.origin['organ_type'] == 2"
                ></i>
                <i
                  nz-icon
                  nzIconfont="icon_company"
                  class="structure-icon mr-sm"
                  *ngIf="node.level == 0 && node.origin['organ_type'] == 3"
                ></i>
                <i
                  nz-icon
                  nzIconfont="icon_supply"
                  class="structure-icon mr-sm"
                  *ngIf="node.level == 0 && node.origin['organ_type'] == 4"
                ></i>
                <i
                  nz-icon
                  nzIconfont="icon_jiagou"
                  class="structure-icon mr-sm"
                  *ngIf="node.level != 0 && node.origin['organ_type_extra'] == 1"
                ></i>
                <i
                  nz-icon
                  nzIconfont="icon_pianqu"
                  class="structure-icon mr-sm"
                  *ngIf="node.level != 0 && node.origin['organ_type_extra'] == 2"
                ></i>
                <i
                  nz-icon
                  nzIconfont="icon_arrive"
                  class="structure-icon mr-sm"
                  *ngIf="node.level != 0 && node.origin['organ_type'] == 1 && node.origin['organ_type_extra'] == 3"
                ></i>
                <i
                  nz-icon
                  nzIconfont="icon_jiagou"
                  class="structure-icon mr-sm"
                  *ngIf="node.level != 0 && node.origin['organ_type'] != 1 && node.origin['organ_type_extra'] == 3"
                ></i>
                <i
                  nz-icon
                  nzIconfont="icon_zu"
                  class="structure-icon mr-sm"
                  *ngIf="node.level != 0 && node.origin['organ_type_extra'] == 4"
                ></i>
                <i nz-icon nzIconfont="icon_duties" class="structure-icon mr-sm" *ngIf="node.origin['organ_type'] == 5"></i>
                {{ node.title }}
              </ng-template>
            </nz-tree>
          </div>
          <div class="all-width pt-12 pl-md pr-md" *ngIf="leftSearch != '' && searchData.length > 0">
            <label nz-checkbox [(ngModel)]="checkAll" class="select-item ml-12" (ngModelChange)="allCheck($event)" *ngIf="!nzMultiple"
              >全选</label
            >
            <cdk-virtual-scroll-viewport [itemSize]="54" style="width: 100%" [ngStyle]="{ height: !nzMultiple ? '328px' : '360px' }">
              <ng-container *ngFor="let item of searchData; let index = index">
                <div class="employee-item pl-12 clickEle flexRow">
                  <label
                    nz-checkbox
                    [ngModel]="selectIds.indexOf(item['key']) > -1"
                    (ngModelChange)="selectData(item['key'], index, $event)"
                    style="min-width: 16px"
                    class="mr-sm"
                    *ngIf="!nzMultiple"
                  >
                  </label>

                  <div class="employee-item-info flexColumn" (click)="selectData(item['key'], index, $event)">
                    <div>
                      <i nz-icon nzIconfont="icon_duties" class="structure-icon mr-sm"></i>
                      {{ item['title'] }}
                    </div>
                    <div style="max-width: 370px; padding-left: 20px" class="text-gray1 mt-xs text-truncate">
                      {{ item['path'] }}
                    </div>
                  </div>
                </div>
              </ng-container>
            </cdk-virtual-scroll-viewport>
          </div>
          <ng-container *ngIf="leftSearch != '' && searchData.length == 0">
            <div class="no-data-box">
              <img src="assets/no-data.png" class="no-data-img" />
              <div class="text-gray2 all-width text-center">暂无数据</div>
            </div>
          </ng-container>
          <!--            底部选择框 End-->
        </div>
        <div class="result-box flexFull flexColumn">
          <!--            顶部title-->
          <div class="box-title pl-12 flexRow">
            <div>已选部门</div>
            <div class="ml-sm text-xs text-gray1">({{ selectIds.length }}项)</div>
            <div class="flexFull"></div>
            <div class="mr-md text-primary clickEle" (click)="clear()">清空</div>
          </div>

          <!--            顶部title End-->
          <!--            中部搜索框-->
          <div class="all-width pl-md pr-md mt-12">
            <nz-input-group [nzPrefix]="searchIcon">
              <input nz-input class="selfRadius" placeholder="搜索部门" [ngModel]="rightSearch" (ngModelChange)="setRightSearch($event)" />
            </nz-input-group>
          </div>
          <!--            中部搜索框 End-->
          <div class="all-width pl-md pr-md mt-12">
            <cdk-virtual-scroll-viewport [itemSize]="40" style="height: 362px">
              <ng-container *ngFor="let item of selectResult; let index = index">
                <div
                  *ngIf="rightSearch == '' || item['title'].indexOf(rightSearch) > -1"
                  class="select-result-item mb-sm pl-12 flexRow pr-md"
                >
                  <i nz-icon nzIconfont="icon_duties" class="structure-icon mr-sm"></i>
                  <div class="flexFull">{{ item['title'] }}</div>
                  <i nz-icon nzType="close-circle" nzTheme="outline" class="text-gray1 clickEle" (click)="delete(item, index)"></i>
                </div>
              </ng-container>
            </cdk-virtual-scroll-viewport>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</my-feedback>
<ng-template #searchIcon>
  <i nz-icon nzIconfont="icon_search" class="text-gray1"></i>
</ng-template>
